/*
  @route    GET https://REACT_APP_API_URL/contact
  @desc     Get general info for contact
  @access   Public
*/
export async function getContactContent(id) {
  try {
    const url = `https://p01--afix-payload-mk2--w7xsf9cwbfgg.code.run/api/contact`;
    const response = await fetch(url, {
      method: "GET",
      // mode: "no-cors",
    });
    // console.log(response);
    const result = await response.json();
    // console.log(result);
    return { response, result };
  } catch (error) {
    console.log(error);
    return null;
  }
}
